var Apidae_FullMap = (function(){
    var self = {};
    var map;
    var prestas;
    var markers = [];
    var mapIconOff = apidae.base_url + apidae.theme_url + '/img/mapIcon/mapIconOff.png';
    var mapIconOn = apidae.base_url + apidae.theme_url + '/img/mapIcon/mapIconOn.png';
    var zoomChanged;
    var dragend;

    self.setMarkers = function(reqTif) {
        /* Déclaration de l'objet qui définira les limites de la map */
        var bounds = new google.maps.LatLngBounds();

        google.maps.event.removeListener(zoomChanged);
        google.maps.event.removeListener(dragend);

        // delete existing marker and infobox
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
            markers[i].infobox.close();
        }

        markers = [];

        var url = apidae.base_url + '/services/getPrestasMap/';

        if(reqTif) {
            Apidae_Util.ajaxSend();

            $.ajax({
                method: "GET",
                url: url,
                data: 'reqTif=' + reqTif + '&lang=' + apidae.lang_url,
                dataType: 'json',
                success: function (data) {
                    if (data.status == 'OK') {
                        prestas = data.prestas;
                        // loop through prestas and add markers
                        for (p in prestas) {
                            //create gmap latlng obj
                            tmpLatLng = new google.maps.LatLng(prestas[p].latitude, prestas[p].longitude);
                            // make and place map maker.
                            var marker = new google.maps.Marker({
                                map: map,
                                position: tmpLatLng,
                                title: prestas[p].title,
                                icon: mapIconOff
                            });

                            var southLat = $('#South_Lat').val();
                            var southLng = $('#South_Lng').val();
                            var northLat = $('#North_Lat').val();
                            var northLng = $('#North_Lng').val();

                            // Extension des limites (bounds) de la map grâce à la méthode extend
                            if (southLat > 0 && southLng > 0 && northLat > 0 && northLng > 0) {

                                var sw = new google.maps.LatLng(southLat, southLng);
                                var ne = new google.maps.LatLng(northLat, northLng);

                                bounds.extend(sw);
                                bounds.extend(ne);
                            } else {
                                bounds.extend(tmpLatLng);
                            }

                            bindInfoWindowInfoBox(marker, map, prestas[p].infoHtml);

                            // not currently used but good to keep track of markers
                            markers.push(marker);
                        }

                        /* zoom de la map en fonction des limites */
                        if (reqTif) {
                            map.fitBounds(bounds);
                        }

                        /* Ajustement du niveau de zoom */
                        var zoomLevel = $('#Zoom_Level').val();
                        if (zoomLevel > 0) {
                            map.setZoom(parseInt(zoomLevel));
                        }
                        Apidae_Util.ajaxComplete();
                    }
                },
                complete: function () {

                    zoomChanged = google.maps.event.addListener(map, 'zoom_changed', function () {

                        if ($("#searchByMap").is(':checked')) {
                            /* niveau de zoom de la map */
                            var zl = map.getZoom();
                            $('#Zoom_Level').val(zl);

                            /* coordonnées des coins de la map */
                            var bds = map.getBounds();
                            var South_Lat = bds.getSouthWest().lat();
                            var South_Lng = bds.getSouthWest().lng();
                            var North_Lat = bds.getNorthEast().lat();
                            var North_Lng = bds.getNorthEast().lng();
                            $('#South_Lat').val(South_Lat);
                            $('#South_Lng').val(South_Lng);
                            $('#North_Lat').val(North_Lat);
                            $('#North_Lng').val(North_Lng).trigger("change");

                            Apidae_Search.search();
                        }
                    });

                    dragend = google.maps.event.addListener(map, 'dragend', function () {
                        if ($("#searchByMap").is(':checked')) {
                            google.maps.event.trigger(this, 'zoom_changed');
                        }
                    });

                }
            });
        }
    };

    // binds a map marker and infoBox together on click
    var bindInfoWindowInfoBox = function(marker, map, html) {
        var boxText = document.createElement("div");
        boxText.style.cssText = "margin-bottom: 10px; background-color: #20232b; padding-bottom: 10px;";
        boxText.innerHTML = html;

        var myOptions = {
            content: boxText
            ,alignBottom: true
            ,disableAutoPan: false
            ,maxWidth: 0
            ,pixelOffset: new google.maps.Size(-140, -60)
            ,zIndex: null
            ,boxStyle: {
                background: "url('" + apidae.base_url + apidae.theme_url + "/img/mapIcon/tipBox.png') bottom center no-repeat"
                ,opacity: 1
                ,width: "280px"
                ,height: "245px"
            }
            ,closeBoxMargin: "2px 2px 2px 2px"
            ,closeBoxURL: apidae.base_url + apidae.theme_url + '/img/close.png'
            ,infoBoxClearance: new google.maps.Size(1, 1)
            ,isHidden: false
            ,pane: "floatPane"
            ,enableEventPropagation: false
        };

        google.maps.event.addListener(marker, "click", function (e) {

            for (var h = 0; h < markers.length; h++) {
                markers[h].setIcon(mapIconOff);
                markers[h].infobox.close();
            }
            this.setIcon(mapIconOn);

            this.infobox.open(map, this);
        });
        marker.infobox = new InfoBox(myOptions);

    };

    self.init = function(){

        // Close filter dropdown inside lateral .cd-filter and Search
        $('.sidebar-map').on('click','.cd-filter-block input.filter',function(){
            var input = $(this);
            var block = input.closest('.cd-filter-block');
            var reqTif = input.val();
            //console.log(reqTif);
            block.find('label').removeClass('select');
            input.siblings('label').addClass('select');
            block.siblings('.cd-filter-block').find('h4').addClass('closed').siblings('.cd-filter-content').slideUp(300);
            block.find('h4').removeClass('closed').siblings('.cd-filter-content').slideDown(300);
            self.setMarkers(reqTif);
        });

        // Map option
        var mapOptions = {
            center: new google.maps.LatLng(43.423014, 6.817706),
            zoom: 12,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false
        };

        // create the map
        map = new google.maps.Map(document.getElementById("fullMapPrestas"), mapOptions);

        // fetch the prestas (ajax) and put them on the map
        self.setMarkers(null);

        loadData = false;

    };

    self.resize = function(){
        //google.maps.event.trigger(map, 'resize');
        var center = map.getCenter();
        google.maps.event.trigger(map, 'resize');
        map.setCenter(center);
        map.setZoom(12);
    };

    return self;
})();

$(window).load(function(){
    if($('#fullMapPrestas').length) {
        Apidae_FullMap.init();
    }
});
